export enum HeadlessCategory {
  Screenshot = 'Screenshot',
  Thumbnail = 'Thumbnail',
}
export enum HeadlessJobFormat {
  PNG = 'PNG',
  PDF = 'PDF',
  REACT_JSON = 'REACT_JSON',
}
